import { render, staticRenderFns } from "./el_services.vue?vue&type=template&id=f06d0298&scoped=true"
import script from "./el_services.vue?vue&type=script&lang=js"
export * from "./el_services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06d0298",
  null
  
)

export default component.exports